/**
 * Generates a phone-like anonymous identifier for sessions where phone number
 * collection is disabled. Uses country code +000 (invalid/reserved) so it
 * structurally resembles a phone number but can never match a real one.
 */
export function generateAnonymousId(): string {
  const randomDigits = Math.floor(Math.random() * 900000000) + 100000000;
  return `+000${randomDigits}`;
}
